import { render, staticRenderFns } from "./CloseIconThick.vue?vue&type=template&id=4cb8712d&"
import script from "./CloseIconThick.vue?vue&type=script&lang=js&"
export * from "./CloseIconThick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports